import axios from "axios"

function log(event) {
    axios.post(
        process.env.REACT_APP_API_HOST + '/test/',
        {
            event: event,
        }
    ).then(
        (response) => {

        }
    ).catch(
        (error) => {

        }
    )
}

export { log }